var map = {
	"./hero-bg-1200.jpg": 1997,
	"./hero-bg-1200.webp": 1998,
	"./hero-bg-1200x2.jpg": 1999,
	"./hero-bg-1200x2.webp": 2000,
	"./hero-bg-1600.jpg": 2001,
	"./hero-bg-1600.webp": 2002,
	"./hero-bg-1600x2.jpg": 2003,
	"./hero-bg-1600x2.webp": 2004,
	"./hero-bg-1920.jpg": 2005,
	"./hero-bg-1920.webp": 2006,
	"./hero-bg-1920x2.jpg": 2007,
	"./hero-bg-1920x2.webp": 2008,
	"./hero-bg-2560.jpg": 2009,
	"./hero-bg-2560.webp": 2010,
	"./hero-bg-580.jpg": 2011,
	"./hero-bg-580.webp": 2012,
	"./hero-bg-580x2.jpg": 2013,
	"./hero-bg-580x2.webp": 2014,
	"./hero-bg-800.jpg": 2015,
	"./hero-bg-800.webp": 2016,
	"./hero-bg-800x2.jpg": 2017,
	"./hero-bg-800x2.webp": 2018,
	"./hero-bg-full.jpg": 2019,
	"./hero-bg-full.webp": 2020
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1996;